import { render } from "./EthicsAndCompliance.vue?vue&type=template&id=2dfc8a84"
import script from "./EthicsAndCompliance.vue?vue&type=script&lang=js"
export * from "./EthicsAndCompliance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__